import * as z from 'zod';
import { Get as Get$1 } from './contract/contract-surety-quote-preview.dto.mjs';
import * as contractSuretyQuotePreview_dto from './contract/contract-surety-quote-preview.dto.mjs';
export { contractSuretyQuotePreview_dto as Contract };

var Get;
(function (Get) {
    (function (Response) {
        Response.schema = z.discriminatedUnion("suretyType", [Get$1.Response.schema]);
    })(Get.Response || (Get.Response = {}));
})(Get || (Get = {}));

export { Get };
